import React from 'react'
import CSSModules from 'react-css-modules'
import { IconButton } from 'react-toolbox/lib/button'
import notifyHoc from 'containers/App/Notification/Notify'
import T from 'i18n-react'

import theme from './FilterButton.scss'

const InfoButton = notifyHoc(IconButton)
/*
const FilterButton = (props) => (
  <Button
    flat
    icon='filter_list'
    label="FILTER"
    theme={theme}
    onClick={() => props.onClick()}
  />
)
*/

const FilterButton = (props) => (
  <InfoButton
    icon='filter_list'
    theme={theme}
    message={T.translate('pages.project.approvals.notification.filter')}
    onClick={() => props.onClick()}
  />
)


export default CSSModules(FilterButton, theme)
